export enum InsertPosition {
  Above = 1,
  Below = 2,
  Inside = 3,
}
